
import "./Roadmap.scss"



export default function () {


    return (
        <div style={{ background: "radial - gradient(at bottom left, rgba(9, 8, 68, 1), transparent 1300px), radial- gradient(at bottom right, rgb(36 110 119), transparent 1500px), radial - gradient(at center left, rgba(33, 29, 43, 1), transparent 1300px), radial - gradient(at center right, rgba(9, 8, 68, 1), transparent 1800px), radial - gradient(at top right, rgba(97, 120, 104, 1), transparent 400px), radial - gradient(at top left, rgba(9, 8, 68, 1), transparent 2000px)" }}>
            <section class="ps-timeline-sec" >
                <div class="container">
                    <ol class="ps-timeline">
                        <li>
                            <div class="ps-top">
                                <h4 style={{ marginBottom: "15px" }}>Phase 1</h4>
                                <p style={{ color: "#42d5c1" }}>1.Introducing website, Twitter and Instagram.</p>
                                <p style={{ color: "#42d5c1" }}>2.Building Community and raising awareness of Blockchain,WEB3.0,NFT and Crypto currencies.</p>
                                <p style={{ color: "#42d5c1" }}>3.Contests to win NFT, Cash prizes, etc. (Discord Server).</p>
                                <p style={{ color: "#42d5c1" }}>4.Sneak-peak of NFT art and distribution of our crypto to first 100 #42d5c1list users.</p>
                            </div>
                            <div class="ps-bot">
                                <h2>June '22</h2>
                            </div>
                            <span class="ps-sp-top">01</span>
                        </li>
                        <li>
                            <div class="ps-bot">
                                <h4 style={{ marginBottom: "15px" }}>Phase 2</h4>
                                <p style={{ color: "#42d5c1" }}>1.Introduce $KULL ,our utility token.</p>
                                <p style={{ color: "#42d5c1" }}>2.Distribution of $KULL to community users on Discord.</p>
                                <p style={{ color: "#42d5c1" }}>3.NFT holders party and utility discloser.</p>
                                <p style={{ color: "#42d5c1" }}>4.Minting will be open for pre and public sale.</p>
                            </div>
                            <div class="ps-top">
                                <h2>Oct '22</h2>
                            </div>
                            <span class="ps-sp-bot">02</span>
                        </li>
                        <li>
                            <div class="ps-top">
                                <h4 style={{ marginBottom: "15px" }}>Phase 3</h4>
                                <p style={{ color: "#42d5c1" }}>1.Sneak-peak of our Metaverse METAKUL.</p>
                                <p style={{ color: "#42d5c1" }}>2.Introducing breeding of the NFT's, and providing Serum to breed METAKUL.</p>
                                <p style={{ color: "#42d5c1" }}>All holders will have direct invitation to our Meta-Festivals.</p>
                        </div>
                            <div class="ps-bot">
                                <h2>Dec '22</h2>
                            </div>
                            <span class="ps-sp-top">03</span>
                        </li>
                        <li>
                            <div class="ps-bot">
                                <h4 style={{ marginBottom: "15px" }}>Phase 4</h4>
                                <p style={{ color: "#42d5c1" }}>1.Upcoming P2E games in metaverse.</p>
                                <p style={{ color: "#42d5c1" }}>2.Start of Digital Education In first ever Digital Gurukul.</p>
                                <p style={{ color: "#42d5c1" }}>NFT Projects to mint only for $KULL holders.</p>
                            </div>
                            <div class="ps-top">
                                <h2>Feb '23</h2>
                            </div>
                            <span class="ps-sp-bot">04</span>
                        </li>
                        <li>
                         
                           
                           
                        </li>
                     
                    </ol>
                </div>
            </section>
        </div>
          
    );
}
